import React from 'react';
import './EquipesInstallationManagement.css';

const EquipePerformanceDetail = ({ performance, onBack }) => {
    if (!performance) return null;

    return (
        <div className="eqi-performance-detail-page">
            <div className="eqi-header-row" style={{ marginBottom: '20px' }}>
                <div>
                    <button className="eqi-btn eqi-btn-secondary" onClick={onBack} style={{ marginBottom: '15px' }}>
                        &larr; Retour à la liste
                    </button>
                    <h1 className="eqi-title">🏆 Performances de l'Équipe</h1>
                    <p className="eqi-subtitle">
                        <strong>Type :</strong> {performance.equipeDetails?.typeEquipe} | <strong>Chef d'équipe :</strong> {performance.equipeDetails?.chefEquipe?.nom} {performance.equipeDetails?.chefEquipe?.prenom}
                    </p>
                </div>
            </div>

            <div className="eqi-perf-content" style={{ background: '#fff', padding: '24px', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                <div className="eqi-perf-grid" style={{ marginBottom: '30px' }}>
                    <div className="eqi-perf-card eqi-perf-green">
                        <span className="eqi-perf-icon">✅</span>
                        <div className="eqi-perf-data">
                            <p className="eqi-perf-val">{performance.allTime?.clients || 0}</p>
                            <p className="eqi-perf-lbl">Clients (Total)</p>
                        </div>
                    </div>
                    <div className="eqi-perf-card eqi-perf-orange">
                        <span className="eqi-perf-icon">⚡</span>
                        <div className="eqi-perf-data">
                            <p className="eqi-perf-val">{performance.allTime?.kwc || 0} kWc</p>
                            <p className="eqi-perf-lbl">Puissance (Total)</p>
                        </div>
                    </div>
                    <div className="eqi-perf-card eqi-perf-blue">
                        <span className="eqi-perf-icon">📅</span>
                        <div className="eqi-perf-data">
                            <p className="eqi-perf-val">{performance.thisMonth?.clients || 0}</p>
                            <p className="eqi-perf-lbl">Ce Mois</p>
                        </div>
                    </div>
                    <div className="eqi-perf-card eqi-perf-purple">
                        <span className="eqi-perf-icon">📈</span>
                        <div className="eqi-perf-data">
                            <p className="eqi-perf-val">{performance.thisWeek?.clients || 0} / {performance.today?.clients || 0}</p>
                            <p className="eqi-perf-lbl">Cette Semaine / Auj.</p>
                        </div>
                    </div>
                </div>
                
                <div style={{ marginTop: '20px' }}>
                    <h3 style={{ marginBottom: '15px', fontSize: '1.2rem', color: '#1f2937', borderBottom: '1px solid #e5e7eb', paddingBottom: '10px' }}>
                        Clients affectés ({performance.clients?.length || 0})
                    </h3>
                    <div className="eqi-table-wrap" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                        <table className="eqi-main-table">
                            <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                <tr>
                                    <th>Client</th>
                                    <th>Réf STEG</th>
                                    <th>Téléphone</th>
                                    <th>Puissance</th>
                                    <th>Date Installation</th>
                                    <th>Statut</th>
                                </tr>
                            </thead>
                            <tbody>
                                {performance.clients?.length === 0 ? (
                                    <tr><td colSpan="6" className="eqi-empty-cell" style={{ textAlign: 'center', padding: '20px' }}>Aucun client installé.</td></tr>
                                ) : (
                                    performance.clients?.map(c => (
                                        <tr key={c._id}>
                                            <td><strong>{c.nom} {c.prenom}</strong></td>
                                            <td>{c.referenceSteg}</td>
                                            <td>{c.telephone}</td>
                                            <td>{c.puissance} kWc</td>
                                            <td>{c.dateLivraison ? new Date(c.dateLivraison).toLocaleDateString('fr-FR') : '—'}</td>
                                            <td><span className="eqi-type-pill">{c.statut}</span></td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EquipePerformanceDetail;
